<!--  -->
<template>
  <div class="page" :class="{ active: isApp || miniprogram }">
    <common-title
      v-if="!isApp && !miniprogram"
      :goHome="true"
      titleName="SVIP课程体验"
      :zIndex="1000"
    ></common-title>
    <img
      class="main"
      src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/svipProduct/img_009.png"
      alt=""
    />
    <div class="tab">
      <div
        class="subject"
        :class="{ active: idx === k }"
        @click="changeSubject(item, 1, k)"
        v-for="(item, k) in pageData"
        :key="k"
      >
        {{ item.majorName }}
      </div>
    </div>
    <!-- 师资 -->
    <div class="teacher">
      <div class="banner">
        <div class="slide" v-for="(item, k) in teacherList" :key="k" @click="toTeacherDetail(item)">
          <div class="head">
            <img
              class="img"
              :src="item.topicWebHead || require('../../assets/img/loginImg/default.png')"
              alt=""
            />
            <div class="name">{{ item.publicName }}</div>
          </div>
          <div class="desc">
            <span v-for="item2 in renderTeacherDesc(item.id)" :key="item.id">{{item2}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="courseHight">
      <img @click="openExamSeason" class="courseHight_top" src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/svipProduct/img_003.png" />
      <div class="courseHight_bottom">
        <img @click="toEnery(0)" src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/svipProduct/img_005.png" />
        <img @click="toEnery(6)" src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/svipProduct/img_008.png" />
      </div>
    </div>
    <div class="foot" @click="openExamSeason">
      <img src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/svipProduct/img_001.png">
    </div>
    <div class="chat" @click="openChat">
      <img
        src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/svipProduct/img_004.png"
        alt=""
      />
    </div>
    <van-popup v-model="showPop" position="bottom" class="selectExamSeason" :close-on-click-overlay="false">
      <div @click="selectExamSeason(1)" :class="{season:true,active:seaSonModul === 1}">26考研SVIP</div>
      <div @click="selectExamSeason(2)" :class="{season:true,active:seaSonModul === 2}">27考研SVIP</div>
    </van-popup>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';
import { mapState } from 'vuex';
import { reqCourseExperience, reqBokecc } from '@/api/vipProduct/index';
import { reqTeacherList, reqIsBuyProduct, reqCourseDetail } from '@/api/courseDetail/index';
import { reqSubOrder } from '@/api/pay/index';
import {teacherDesc} from './data'
import {reqTypeList} from "@/api/home";

export default {
  components: {},
  data() {
    return {
      pageData: [],
      teacherDesc:teacherDesc,
      isApp: this.$root.$data.isApp,
      miniprogram: this.$root.$data.miniprogram,
      subjectList: [],
      childMajorList: [],
      idx: 0,
      subIdx: 0,
      experienceId: 0,
      vipCourseDetail: {},
      energyList: [],
      wordVOList: [],
      teacherList: [],
      videoUrl: '',
      playStatus: false,
      showPop:false,
      seaSonModul:0,
      subjectType:1,
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  watch: {},
  methods: {
    async getTypeList() {
      const res = await reqTypeList('SIVP_PAGEDATA');
      if (res.code === 0) {
        const data = []
        res?.data.forEach(item=>{
          data.push(JSON.parse(item.remark))
        })
        this.pageData = data
      }
    },
    // 匹配师资介绍
    renderTeacherDesc(id){
      return this.teacherDesc[id]
    },
    // 初始化查学科
    async getSubject() {
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true,
      });
      const info = this.pageData.filter(item => item.subjectType === 1)
      this.getTeacher(info[0].teacherIds);
      this.$toast.clear()
    },
    // 查权益--根据ID
    async getCourseDetail(id) {
      const { data } = await reqCourseExperience(id);
      const { vipCourseExperienceBenefitsRespVO } = data;
      const { benefitsKineticEnergyVOList, benefitsExamAssuranceVOList, teacherIds, videoVid } =
        vipCourseExperienceBenefitsRespVO;
      this.vipCourseDetail = data;
      this.energyList = benefitsKineticEnergyVOList;
      this.wordVOList = benefitsExamAssuranceVOList;
      this.getTeacher(teacherIds);
      this.getVideoUrl(videoVid);
      this.$toast.clear();
    },
    // 查教师列表
    async getTeacher(teacherIds) {
      const { data } = await reqTeacherList(teacherIds);
      this.teacherList = data;
    },
    // 查视频URL
    async getVideoUrl(vid) {
      const { data } = await reqBokecc(vid);
      this.videoUrl = data?.video?.copy[0]?.playurl;
    },
    // 查开课状态
    async checkCourse(id) {
      const { data } = await reqIsBuyProduct(id);
      return data.length;
    },
    // 查课程sku
    async getCourseSku(id) {
      const { data } = await reqCourseDetail(id);
      const { productSkuRespVOList } = data;
      return productSkuRespVOList?.[0]?.productSkuId;
    },
    // 切换学科
    async changeSubject(item, type, index) {
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true,
      });
      this.subjectType = item.subjectType
      this.idx = index
      this.seaSonModul = 0 // 重置考季选择
      await this.getTeacher(item.teacherIds);
      this.$toast.clear();
    },
    // 跳教师详情
    toTeacherDetail(data) {
      const url = `${window.location.origin}/ark/svipTeacherDetail?teacherId=${data.id}`;
      if (this.miniprogram) {
        wx.miniProgram.navigateTo({
          url: `/subPackages/webView/webView?url=${encodeURIComponent(url)}`,
        });
        return;
      }
      if (this.isApp) {
        this.$sendToApp('openNewWebView', { url }, false);
        return;
      }
      this.$router.push({
        path: '/vipTeacherDetail',
        query: {
          teacherId: data.id,
        },
      });
    },
    // 跳体验课
    jumpExperience() {
      const id = this.experienceId;
      const url = `${window.location.origin}/ark/svipExperienceProduct?subjectType=${this.subjectType}&seaSonModul=${this.seaSonModul}`;
      if (this.miniprogram) {
        wx.miniProgram.navigateTo({
          url: `/subPackages/webView/webView?url=${encodeURIComponent(url)}`,
        });
        return;
      }
      if (this.isApp) {
        this.$sendToApp('openNewWebView', { url }, false);
        return;
      }
      this.$router.push({
        path: '/svipExperienceProduct',
        query: {
          subjectType:this.subjectType,
          seaSonModul:this.seaSonModul
        },
      });
    },
    toEnery(i) {
      const url = `${window.location.origin}/ark/svipService?active=${i}&subjectType=${this.subjectType}`;
      if (this.miniprogram) {
        wx.miniProgram.navigateTo({
          url: `/subPackages/webView/webView?url=${encodeURIComponent(url)}`,
        });
        return;
      }
      if (this.isApp) {
        this.$sendToApp('openNewWebView', { url }, false);
        return;
      }
      this.$router.push({
        path: '/svipService',
        query: {active: i,subjectType:this.subjectType},
      });
    },
    openChat() {
      let url =
        'https://pg-chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=689e8f5dbce9490001a460c4';
      if (this.$root.$data.isApp) {
        this.$sendToApp(
          'openNewWebView',
          {
            url,
          },
          false,
        );
        return;
      }
      if (this.$root.miniprogram) {
        const jumpUrl = `/subPackages/webView/webView?url=${encodeURIComponent(url)}`;
        wx.miniProgram.navigateTo({
          url: jumpUrl,
        });
        return;
      }
      window.open(url);
    },
    // 去登录
    toLogin() {
      if (this.isApp) {
        this.$sendToApp('newLogin', {clientType: 38, address:window.location.href}, true);
      } else if (this.miniprogram) {
        let url = window.location.href;
        const [domain, searchParams] = url.split('?');
        if (searchParams) {
          const params = searchParams.split('&');
          const paramsMap = new Map();
          params.forEach((item) => {
            const [key, value] = item.split('=');
            //  console.log('key', key, value);
            if (key) {
              paramsMap.set(key, value);
            }
          });
          const entries = paramsMap.entries();
          let query = '';
          const ExcludequeryArr = ['THIRD_SESSION', 'env'];
          // eslint-disable-next-line no-restricted-syntax
          for (const [key, value] of entries) {
            if (!ExcludequeryArr.includes(key)) query += `${key}=${value}&`;
          }
          url = `${domain}?${query}`;
          const redirctUrl = encodeURIComponent(
            `/subPackages/detailWebView/index?url=${encodeURIComponent(url)}`,
          );
          const path = `/subPackages/loginPage/loginPage?isHandle=1&isWebview=1&isCancelgoBack=1&redirctUrl=${redirctUrl}`;
          wx.miniProgram.redirectTo({
            url: path,
          });
        }
      } else {
        this.$router.push({
          path: '/registrationLogin',
          query: { redirect: '/svipCourse' },
        });
      }
    },
    openExamSeason(){
      if (!this.userInfo?.id) {
        this.toLogin();
        return;
      }
      this.showPop = true
    },
    selectExamSeason(id){
      this.seaSonModul = id
      const that = this
      setTimeout(()=>{
        that.showPop = false
        const subjectInfo = this.pageData.filter(item=>item.subjectType === this.subjectType)
        console.log('subjectInfo',subjectInfo)
        const courseId = (id ===1) ? subjectInfo[0]?.seaSonCourse26 : subjectInfo[0]?.seaSonCourse27
        console.log('courseId',courseId)
        that.toExperienceCourse(courseId)
      },282)
    },
    // 去体验课
    async toExperienceCourse(id) {
      const courseId = id
      if (!this.userInfo?.id) {
        this.toLogin();
        return;
      }
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true,
      });
      const isBuy = await this.checkCourse(courseId);
      if (isBuy) {
        this.$toast.clear();
        this.jumpExperience();
      } else {
        const skuid = await this.getCourseSku(courseId);
        const subData = {
          // 订单提交请求对象
          channelMark: 5, // 下单渠道 ：5学员端下单
          products: [
            {
              productId: courseId,
              quantity: 1, // 产品数量
              type: 1, // 产品类别 1-主产品 2-增值产品 3-赠送产品
            },
          ],
          terminalMark: this.$global.terminalMark,
          orderReferer: '',
          // eslint-disable-next-line no-undef
          ip: sessionStorage.getItem('cityIp') || '',
          orderUrl: window.location.href,
        };
        subData.products[0].productSkuId = skuid;
        const { code, msg } = await reqSubOrder(subData);
        if (code === 0) {
          this.$toast('试听课程领取成功');
          this.jumpExperience();
        } else {
          this.$toast(msg);
        }
      }
    },
    async getLoginAfter() {
      await this.$root.getUserInfo();
    },
    // app 登录回掉
    getLogin(APPSESSION) {
      const ua = navigator.userAgent.toLowerCase();
      const cookieToken = /ohos/.test(ua) ? APPSESSION.token : APPSESSION;
      if ((window?.navigator?.userAgent || '').includes('iqihang')) {
        window.localStorage.setItem('accessToken', cookieToken || '');
        this.getLoginAfter();
      }
    },
  },
  created() {},
  async mounted() {
    await this.getTypeList()
    this.getSubject();
    document.title = 'SVIP课程体验';
    window['iqhApp2jsBridge.triggerSC'] = {};
    setTimeout(() => {
      // 获取登录状态
      window['iqhApp2jsBridge.triggerSC'].getLogin = this.getLogin;
    }, 100);
  },
  destroyed() {},
};
</script>
<style lang="scss" scoped>
::-webkit-scrollbar {
  display: none;
}
.page.active {
  padding-top: 0;
}
.page {
  width: 100%;
  max-width: 750px;
  min-height: 100vh;
  margin:0 auto;
  padding-top: 100px;
  padding-bottom: 210px;
  background: #0D0737;
  .main {
    width: 100%;
    height: 100%;
  }
  .tab {
    display: flex;
    padding: 0 36px;
    justify-content: space-between;
    .subject {
      box-sizing: border-box;
      width: 214px;
      height: 65px;
      margin-right: 7px;
      color: #6A7EB0;
      font-weight: 500;
      font-size: 25px;
      line-height: 65px;
      text-align: center;
      background: rgba(16, 18, 39, 1);
      border: 1px solid rgba(65, 65, 101, 1);
      border-radius: 8px;
    }
    .subject.active {
      height: 80px;
      color: #63310F;
      line-height: 65px;
      background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/svipProduct/img_010.png') no-repeat;
      background-size: 100%;
      border: none;
    }
  }
  .sub-tab {
    display: flex;
    flex-shrink: 0;
    flex-wrap: nowrap;
    align-items: center;
    width: 678px;
    height: 58px;
    margin: 22px auto 0;
    overflow-x: scroll;
    white-space: nowrap;
    background: #fff;
    border-radius: 14px;
    .major {
      position: relative;
      flex: 0 0 auto;
      height: 58px;
      margin-right: 15px;
      padding: 0 18px;
      color: #333;
      font-weight: 400;
      font-size: 25px;
      line-height: 58px;
    }
    .major.active {
      color: #9a6f45;
      font-weight: 400;
      font-size: 25px;
    }
    .major.active::after {
      position: absolute;
      right: 0;
      bottom: 0;
      left: 0;
      display: block;
      width: 29px;
      height: 7px;
      margin: 0 auto;
      background: #9a6f45;
      border-radius: 4px;
      content: '';
    }
  }
  .teacher {
    box-sizing: border-box;
    width: 678px;
    height: 362px;
    margin: 22px auto;
    background: url("https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/svipProduct/img_006.png") no-repeat;
    background-size: 100% 100%;
    border-radius: 14px;
    padding-top: 98px;
    .title {
      display: block;
      width: 197px;
      height: 58px;
      margin: 0 auto;
    }
    .banner {
      display: flex;
      flex-shrink: 0;
      flex-wrap: nowrap;
      align-items: flex-start;
      margin-left: 22px;
      overflow-x: scroll;
      .slide:last-child {
        margin-right: 22px;
      }
      .slide {
        width: 199px;
        margin-right: 11px;
        .head {
          position: relative;
          width: 100%;
          height: 163px;
          overflow: hidden;
          text-align: center;
          background: rgba(35, 38, 66, 1);
          border-radius: 14px;
          border-top: 1px solid rgba(65, 66, 165, 1);
          border-left: 1px solid rgba(65, 66, 165, 1);
          border-right: 1px solid rgba(65, 66, 165, 1);
          .img {
            position: relative;
            top: 18px;
            width: 90%;
          }
          .name {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 47px;
            color: #0F142B;
            font-weight: 500;
            font-size: 22px;
            line-height: 47px;
            text-align: center;
            background: #A8B0FF;
            border-radius: 0 0 14px 14px;
          }
        }
        .desc {
          display: -webkit-box;
          width: 199px;
          height: 56px;
          margin-top: 18px;
          overflow: hidden;
          color: #63310E;
          font-weight: 400;
          font-size: 22px;
          //line-height: 33px;
          //text-overflow: ellipsis;
          //word-wrap: break-word;
          //overflow: hidden;
          ///* autoprefixer: off */
          //-webkit-box-orient: vertical;
          //-webkit-line-clamp: 2;
          span{
            height: 25px;
            background: linear-gradient( 270deg, #F1B7BB 0%, #FBEBC4 100%);
            border-radius: 5px;
            padding: 0 4px;
            margin-right: 4px;
            font-size: 20px;
            margin-bottom: 6px;
            line-height: 25px;
            display: inline-block;
          }
        }
      }
    }
  }
  .server {
    display: flex;
    justify-content: space-between;
    margin-bottom: 22px;
    padding: 0 36px;
    .title {
      display: block;
      width: 197px;
      height: 58px;
      margin: 0 auto;
    }
    .energy {
      width: 438px;
      background: linear-gradient(180deg, #fff 0%, #fbf2e6 100%);
      border-radius: 14px;
      .list {
        display: flex;
        flex-wrap: wrap;
        padding: 36px 0 18px 26px;
        .item {
          width: 130px;

          img {
            display: block;
            width: 72px;
            height: 72px;
            margin: 0 auto;
          }
          p {
            padding-top: 7px;
            padding-bottom: 18px;
            color: #333;
            font-weight: 400;
            font-size: 22px;
            text-align: center;
          }
        }
      }
    }
    .safeguard {
      width: 217px;
      background: #fff9f2;
      border-radius: 14px;
      .box {
        width: 100%;
        padding: 22px 22px 0 22px;
        .child {
          display: flex;
          align-items: center;
          width: 100%;
          margin-bottom: 22px;
          .icon {
            width: 36px;
            height: 36px;
          }
          p {
            width: 150px;
            padding-left: 4px;
            color: #333;
            font-weight: 400;
            font-size: 22px;
          }
          .arrow {
            width: 9px;
            height: 16px;
          }
        }
      }
    }
  }
  .video {
    position: relative;
    .play {
      display: block;
      width: 620px;
      height: 348px;
      margin: 22px auto;
      border-radius: 14px;
    }
    .empty {
      height: 7px;
    }
    .cover {
      width: 620px;
      height: 348px;
      margin: 22px auto;
      img {
        width: 100%;
      }
    }
  }
  .video,
  .question {
    width: 678px;
    margin: 0 auto;
    background: linear-gradient(180deg, #fff 0%, #fbf2e6 100%);
    border-radius: 14px;
    .title {
      display: block;
      width: 252px;
      height: 58px;
      margin: 0 auto;
    }
    ::v-deep p {
      min-height: 40px;
      color: #333;
      font-weight: 400;
      font-size: 22px;
      font-style: normal;
      line-height: 33px;
      text-align: left;
    }
  }
  .question {
    margin-top: 22px;
    > div {
      padding: 29px;
      ::v-deep p {
        color: #333;
        font-weight: 400;
        font-size: 25px;
        font-style: normal;
        line-height: 33px;
        text-align: left;
      }

      ::v-deep img {
        display: inline-block;
        max-width: 100% !important;
      }
    }
  }
  .courseHight{
    width: 678px;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 0 29px;
    padding-bottom: 29px;
    padding-top: 100px;
    background: url("https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/svipProduct/img_007.png") no-repeat;
    background-size: 100% 100%;
    .courseHight_top{
      width: 100%;
      margin-bottom: 22px;
    }
    .courseHight_bottom{
      width: 100%;
      display: flex;
      justify-content: space-between;
      img{
        width: 300px;
      }
    }
  }
  .foot {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 185px;
    background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/svipProduct/img_002.png')
      no-repeat;
    background-size: 100%;
    padding-top: 33px;
    text-align: center;
    img{
      width: 678px;
      height: 91px;
    }
  }
  .chat {
    position: fixed;
    right: 0;
    bottom: 300px;
    z-index: 100;
    width: 127px;
    img {
      width: 100%;
    }
  }
}
.selectExamSeason{
  width: 100%;
  height: 310px;
  background: #FFFFFF;
  border-radius: 36px 36px 0px 0px;
  overflow: hidden;
  box-sizing: border-box;
  padding-top: 51px;
}
.season{
  width: 100%;
  height: 91px;
  background: #FFFFFF;
  font-weight: 400;
  font-size: 25px;
  color: #333333;
  line-height: 91px;
  text-align: center;
}
.season.active{
  color: #3026D5;
  background: #EFF4FF;
}
</style>
